import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import Paginate from 'vuejs-paginate';
import axios from 'axios';
import { variables } from '../../../../../../config';
import apiUrl from '../../../../../constants';
import resultGrid from '../../../../B2B components/resultGrid';
import { SearchApi } from '../../../../../services/B2BModule/SearDataAPI';
import { HubNameData,hubZoneDropDown,hubDropDown } from '../../../../../services/B2BModule/CommonFuntion';
import {StatusList} from '../../../../../services/B2BModule/B2BStatus';
import {getHubdropdownlist,getZoneList} from '../../../../../services/B2BModule/HubZoneDataAPI';

export default {
  name: 'FinanceExecutivePage',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
    resultGrid
  },
  data() {
    return {
      awbnumber: '',
      token: '',
      pageValue: 0,
      show: false,
      listUserData: [],
      accesszonelist: '',
      parsedata: '',
      isLoading: false,
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      showeditmodel: false,
      editshowtable: false,
      submitDisable: true,
      hubdata:[],
      HubZoneData:[],
      StatusList:[],
      hub: '',
      newhubs:'', 
      showActionColumn:true
   
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.token = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs()
    this.gethubdropdown()
    this.Statusdata()
    this.searchData()

  },
  methods: {

    NewEditPage(awb,status) {
      this.$router.push({ path: '/EditFinanceExecutivepage', query: { awb: awb,status:status } });
    },
    Statusdata()
    {
      StatusList(this.token).then(Reason=>{
          this.StatusList=Reason.data.data
      })
    },
    gethubdropdown() {
      getHubdropdownlist(this.token).then(result => {
        result.data.data.forEach((hub) => {
          this.hubdata.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
        })},

    getzonehubs() {
      getZoneList(this.token).then(result => {
        result.data.data.forEach((hub) => {
          this.HubZoneData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename
          })
        })
      })
    },
  searchData(pageNo,input='') {
    this.isLoading= true;
    this.show2 = true
    this.listUserData = []; this.pagecount = 1; this.totalRows = '';
    this.exportdis = 1;
    this.input = ({
      offset: pageNo,
      limit: variables.pageRecordLimit,
      bucketcode:2
    });
     if(this.awbnumber)
    {
       this.input.shippingid = this.awbnumber;

    }
    if(this.newhubs)
    {
       this.input.hubid = this.newhubs.id;

    }
   if(this.hub)
    {
       this.input.hubzoneid = this.hub.id;

    }
    SearchApi(this.input, this.token)
    .then((result) => {
      this.show2 = false
      this.listUserData = result.data.data;
      this.listUserData.totalCount = result.data.count?result.data.count:0;
      this.listUserData=HubNameData(result.data.data,this.StatusList)
      if (this.totalcount < variables.pageRecordLimit) {
        this.pagecount = 1;
      } else {
        this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit);
      }
    });

  },
    getPaginationData(pageNum, input = '') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum - 1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno, input)
    },

    resetForm() {
      this.hub = this.newhubs = this.awbnumber = ''; this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/B2B/FinanceExecutive/FinanceExecutiveSearchPage/FinanceExecutiveSearchPage.component.js